import Logon from './container/Logon'

export default  Logon;



// WEBPACK FOOTER //
// ./src/views/Logon/index.js